<template>
  <component class="dropdown"
             :is="tag"
             :class="[{show: isOpen}, {'dropdown': direction === 'down'}, {'dropup': direction ==='up'}]"
             aria-haspopup="true"
             :aria-expanded="isOpen"
             @click="toggleDropDown"
             v-click-outside="closeDropDown"
             >
             

    <slot name="title">
      <a class="dropdown-toggle nav-link"
         :class="{'no-caret': hideArrow}"
         data-toggle="dropdown"
         :style="{color:color}">
        <i :class="icon"></i>
        <span class="no-icon">{{title}}</span>
      </a>
    </slot>
    <ul class="dropdown-menu"
        :class="[{'dropdown-menu-right': position === 'right'}, {show: isOpen}]"
        v-if="sinSubmenu==false">
      <slot></slot>
    </ul>
    <ul
        :class="[{'dropdown-menu-right': position === 'right'}, {show: isOpen}]"
        v-if="sinSubmenu==true">
        <slot></slot>
    </ul>
  </component>
</template>
<script>
  export default {
    name: 'drop-down',
    props: {
      color: {
        type: String,
        default: ''
      },
      direction: {
        type: String,
        default: 'down'
      },
      sinSubmenu: {
        type: Boolean,
        default: false
      },
      title: String,
      icon: String,
      position: String,
      hideArrow: {
        type: Boolean,
        default: false
      },
      tag: {
        type: String,
        default: 'li'
      }
    },
    data() {
      return {
        isOpen: false
      }
    },
    provide() {
      return {
        closeDropDown: this.closeDropDown
      }
    },
    methods: {
      toggleDropDown() {
        this.isOpen = !this.isOpen
        this.$emit('change', this.isOpen)
      },
      closeDropDown() {
        this.isOpen = false
        this.$emit('change', this.isOpen)
      }
    }
  }
</script>
<style scoped lang="scss">
  .dropdown {
    list-style-type: none;
  }

  .dropdown .dropdown-toggle {
    cursor: pointer;
  }
  

  
</style>
